<div class="dialog-content bmi-dialog">

  <div mat-dialog-content>
    <h1 class="bmi-dialog-title" [innerHTML]="'reserve-confirm-survey.bmi-calulator' | translate"></h1>
  </div>

  <div class="input-calculator-block">

    <form [formGroup]="form" (ngSubmit)="rightButtonAction()">
      <label>
        <input type="number" formControlName="height"
          [placeholder]="'reserve-confirm-survey.bmi-height-placeholder' | translate"
          maxlength="3"
          (input)="onNumberInput($event, 3, 'height')"
          >
        @if (form.get('height')?.invalid && form.get('height')?.touched) {
        <mat-error class="input-error-msg">
          {{'reserve-confirm-survey.bmi-error' | translate}}
        </mat-error>
        }
      </label>

      <label>
        <input type="number" formControlName="weight"
          [placeholder]="'reserve-confirm-survey.bmi-weight-placeholder' | translate"
          maxlength="3"
          (input)="onNumberInput($event, 3, 'weight')"
          >
        @if (form.get('weight')?.invalid && form.get('weight')?.touched) {
        <mat-error class="input-error-msg">
          {{'reserve-confirm-survey.bmi-error' | translate}}
        </mat-error>
        }
      </label>

      <div class="input-calculator-msg bmi-number">
        <span>{{ 'reserve-confirm-survey.bmi' | translate }}：{{ bmi }}</span>
      </div>

      <div class="dialog-btn-block">
        <button mat-button class="btn-outline-primary btn-size-l" (click)="leftButtonAction()">
          {{ data.leftButtonText }}
        </button>
        <button mat-button class="btn-fill-primary btn-size-l" (click)="rightButtonAction()">
          {{ data.rightButtonText }}
        </button>
      </div>
    </form>
  </div>
